import { authHeader, b64toBlob, isTokenExpired } from "../helpers";
import secureLocalStorage from "react-secure-storage";

export const userService = {
  login,
  loginWithKey,
  logout,
  register,
  getAll,
  getOnlyAdmins,
  create,
  getById,
  update,
  delete: _delete,
  recoverPassword,
  resetPassword,
  validateAccount,
  updateAvatar,
  updateAccountInfo,
  getAccountInfo,
  updatePasswordFromAccount,
  listLastUsersCreated,
  validateEmail,
  sendEmailForUpdate,
  sendEmailForAssociation,
  associateEmail,
  fetchAssociateTags,
  savePassword,
  getUserFrames,
  addUserFrame,
  deleteUserFrame,
  socialLogin,
  updateUserRights,
  updateSuperAdmin,
  getPayments,
  searchUser,
  uploadAvatarVip,
  deleteAvatarVip,
};

function login(username, password) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ login: username, password }),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/accounts/authenticate`,
    requestOptions
  )
    .then(handleResponse)
    .then((user) => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      // localStorage.setItem('user', JSON.stringify(user));
      secureLocalStorage.setItem("user", JSON.stringify(user));
      return user;
    });
}

function recoverPassword(email) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ login: email }),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/reset-password`,
    requestOptions
  ).then((res) => {
    if (res.status === 200) {
      return "An email has been sent to your adress";
    } else {
      const error = (res && res.message) || res.statusText;
      return Promise.reject(error);
    }
  });
}

function validateEmail(key) {
  const requestOptions = {
    method: "PUT",
    headers: { ...authHeader() },
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/accounts/validate-email/${key}`,
    requestOptions
  ).then((res) => {
    if (res.status === 200) {
      return Promise.resolve();
    } else {
      const error = (res && res.message) || res.statusText;
      return Promise.reject(error);
    }
  });
}

function sendEmailForUpdate(email, successToast, errorToast) {
  const requestOptions = {
    method: "PUT",
    headers: { ...authHeader() },
    // headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({ email }),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/accounts/update-email`,
    requestOptions
  ).then((res) => {
    if (res.status === 200) {
      successToast();
      return Promise.resolve();
    } else {
      const error = (res && res.message) || res.statusText;
      errorToast();
      return Promise.reject(error);
    }
  });
}

function sendEmailForAssociation(
  setIsEmailSent,
  email,
  successToast,
  errorToast
) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ email }),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/accounts/associate`,
    requestOptions
  ).then((res) => {
    if (res.status === 200) {
      successToast();
      return Promise.resolve();
    } else {
      const error = (res && res.message) || res.statusText;
      errorToast();
      setIsEmailSent(false);
      return Promise.reject(error);
    }
  });
}

function updatePasswordFromAccount(currentPassword, password) {
  const requestOptions = {
    method: "PUT",
    mode: "cors",
    headers: { ...authHeader() },
    // headers: {'Accept': 'application/json', 'Content-Type': 'application/json'},
    body: JSON.stringify({
      currentPassword,
      password,
    }),
  };

  return fetch(
    process.env.REACT_APP_API_URL + "/account-password",
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((response) => {
      if (response.status === 200) {
        return Promise.resolve();
      } else if (response.status === 403) {
        throw new Error("Wrong current password");
      } else {
        throw new Error("Unable to update account password");
      }
    });
}

function resetPassword(key, password) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ key, password }),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/account-password`,
    requestOptions
  ).then((res) => {
    if (res.status === 200) {
      return "Your password has been modified ! Redirecting...";
    } else {
      const error = (res && res.message) || res.statusText;
      return Promise.reject(error);
    }
  });
  // TRADS ?
}

function logout() {
  // remove user from local storage to log user out
  secureLocalStorage.removeItem("user");
  // localStorage.removeItem('user');
}

function getAll(offset, limit, { login, email, platform, sortModel }) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  let url = "";
  if (sortModel)
    url = `${
      process.env.REACT_APP_API_URL
    }/accounts?offset=${offset}&limit=${limit}&login=${
      login ? login : ""
    }&email=${email ? email : ""}&platform=${
      platform ? platform : ""
    }&sortField=${sortModel.field}&sortOrder=${sortModel.sort.toUpperCase()}`;
  else
    url = `${
      process.env.REACT_APP_API_URL
    }/accounts?offset=${offset}&limit=${limit}&login=${
      login ? login : ""
    }&email=${email ? email : ""}&platform=${platform ? platform : ""}`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then(async (response) => {
      const data = await handleResponse(response);
      try {
        const count = parseInt(response.headers.get("X-Total-Accounts"));
        return {
          result: data,
          count,
        };
      } catch (error) {
        console.error(error);
        return {
          result: data,
          count: data.length,
        };
      }
    });
}

function getOnlyAdmins(offset, limit, { login, email, platform, sortModel }) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };
  let url = "";
  if (sortModel)
    url = `${
      process.env.REACT_APP_API_URL
    }/accounts/admin?offset=${offset}&limit=${limit}&login=${
      login ? login : ""
    }&email=${email ? email : ""}&platform=${
      platform ? platform : ""
    }&sortField=${sortModel.field}&sortOrder=${sortModel.sort.toUpperCase()}`;
  else
    url = `${
      process.env.REACT_APP_API_URL
    }/accounts/admin?offset=${offset}&limit=${limit}&login=${
      login ? login : ""
    }&email=${email ? email : ""}&platform=${platform ? platform : ""}`;

  return fetch(url, requestOptions)
    .then((res) => isTokenExpired(res))
    .then(async (response) => {
      const data = await handleResponse(response);
      try {
        const count = parseInt(response.headers.get("X-Total-Accounts"));
        return {
          result: data,
          count,
        };
      } catch (error) {
        console.error(error);
        return {
          result: data,
          count: data.length,
        };
      }
    });
}

function create(user) {
  const requestOptions = {
    method: "POST",
    headers: authHeader(),
    body: JSON.stringify(user),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/accounts`,
    requestOptions
  ).then(handleResponse);
}

function getById(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/users/${id}`,
    requestOptions
  ).then(handleResponse);
}

function register(user) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(user),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/accounts/register`,
    requestOptions
  ).then(handleResponse);
}

function update(user) {
  const requestOptions = {
    method: "PUT",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(user),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/accounts/${user.id}`,
    requestOptions
  ).then(handleResponse);
}

// prefixed function name with underscore because delete is a reserved word in javascript
function _delete(id) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/accounts/${id}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then(() => true);
}

function validateAccount(key) {
  const requestOptions = {
    method: "PUT",
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/accounts/validate/${key}`,
    requestOptions
  ).then((res) => {
    if (res.status === 200) {
      return Promise.resolve();
    } else {
      const error = (res && res.message) || res.statusText;
      return Promise.reject(error);
    }
  });
}

function associateEmail(key) {
  const requestOptions = {
    method: "PUT",
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/accounts/associate/${key}`,
    requestOptions
  ).then(handleResponse);
}

function handleResponse(response) {
  return response.text().then((text) => {
    const data = text && JSON.parse(text);
    if (!response.ok) {
      if (response.status === 401) {
        // auto logout if 401 response returned from api
        logout();
        // eslint-disable-next-line no-restricted-globals
        location.reload(true);
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }

    return data;
  });
}

async function updateAvatar(infos) {
  const fileName = infos.userId ? `RPM-${infos.userId}.png` : infos.fileName;
  const formData = new FormData();
  let myBlob;
  if (!infos.userId) {
    const res = await fetch(infos.file);
    myBlob = new Blob([await res.blob()], { type: "image/png" });
  }
  formData.append("avatar", infos.userId ? new Blob() : myBlob, fileName);

  const myResponse = async (response) => {
    const data = await handleResponse(response);
    // const user = JSON.parse(localStorage.getItem('user'));
    const user = JSON.parse(secureLocalStorage.getItem("user"));
    if (user) {
      user.accountDetails.avatar = data.avatar;
      secureLocalStorage.setItem("user", JSON.stringify(user));
      // localStorage.setItem('user', JSON.stringify(user));
    }
    return data;
  };
  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(true) },
    body: formData,
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}/accounts/me/avatar`,
    requestOptions
  ).then(myResponse);
}

function updateAccountInfo(data) {
  const requestOptions = {
    method: "PUT",
    headers: { ...authHeader(), "Content-Type": "application/json" },
    body: JSON.stringify(data),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/accounts/me/details`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return "Your account infos has been modified!";
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function getAccountInfo() {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/accounts/me/details`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status === 200) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function listLastUsersCreated() {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/admin/accounts/last`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function fetchAssociateTags(key, value, loaderFunction) {
  const requestOptions = {
    method: "GET",
    headers: { ...authHeader(), "Content-Type": "application/json" },
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/references/${key}/find?name=${value}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        loaderFunction();
        return Promise.reject(error);
      }
    });
}

function loginWithKey(iv, content) {
  const requestOptions = {
    method: "PUT",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ iv, content }),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/users/loginWithKey`,
    requestOptions
  )
    .then(handleResponse)
    .then((user) => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      // localStorage.setItem('user', JSON.stringify(user));
      secureLocalStorage.setItem("user", JSON.stringify(user));
      return user;
    });
}

function savePassword(id, password) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify({ password }),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/accounts/${id}/password`,
    requestOptions
  ).then(handleResponse);
}

function getUserFrames(id) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/accounts/${id}/frames`,
    requestOptions
  ).then(handleResponse);
}

function addUserFrame(id, frameId) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/accounts/${id}/frames/${frameId}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then(() => null);
}

function deleteUserFrame(id, frameId) {
  const requestOptions = {
    method: "DELETE",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/accounts/${id}/frames/${frameId}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then(() => null);
}

function socialLogin(socialUser) {
  const requestOptions = {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ profile: socialUser }),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/accounts/authenticate/social`,
    requestOptions
  )
    .then(handleResponse)
    .then((user) => {
      // store user details and jwt token in local storage to keep user logged in between page refreshes
      // localStorage.setItem('user', JSON.stringify(user));
      secureLocalStorage.setItem("user", JSON.stringify(user));
      return user;
    });
}

function updateUserRights(id, rights) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify({ rights }),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/accounts/${id}/rights`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function updateSuperAdmin(id, right) {
  const requestOptions = {
    method: "PUT",
    headers: authHeader(),
    body: JSON.stringify({ isSuperAdmin: right }),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/accounts/${id}/super`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function getPayments(page, limit) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_GATEWAY_URL}/admin/payments?page=${page}&limit=${limit}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function searchUser(inputValue) {
  const requestOptions = {
    method: "GET",
    headers: authHeader(),
  };

  return fetch(
    `${process.env.REACT_APP_API_URL}/accounts/users/search?search=${inputValue}`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function uploadAvatarVip(userId, file) {
  const formData = new FormData();
  formData.append("avatar", file, file.name.replaceAll(" ", ""));

  const requestOptions = {
    method: "POST",
    headers: { ...authHeader(true) },
    body: formData,
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}/users/${userId}/avatar-vip`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return res.json();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}

function deleteAvatarVip(userId) {
  const requestOptions = {
    method: "DELETE",
    headers: { ...authHeader(true) },
  };
  return fetch(
    `${process.env.REACT_APP_API_URL}/users/${userId}/avatar-vip`,
    requestOptions
  )
    .then((res) => isTokenExpired(res))
    .then((res) => {
      if (res.status < 300) {
        return Promise.resolve();
      } else {
        const error = (res && res.message) || res.statusText;
        return Promise.reject(error);
      }
    });
}
